import { getCapApiConfig } from './config';

/**
 * Base request function for CAP payment API
 * Handles both authenticated (JWT) and session-based requests
 * Uses dynamic base URL based on env parameter
 */
export const sendCapRequest = (
  endpoint: string,
  method: string,
  body?: any,
  sessionId?: string,
  headers: Record<string, string> = {},
  env?: string
) => {
  const { baseUrl } = getCapApiConfig(env);

  const requestHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    ...headers,
  };

  // Add session ID for session-based endpoints
  if (sessionId) {
    requestHeaders['X-Session-Id'] = sessionId;
  }

  return fetch(`${baseUrl}/${endpoint}`, {
    method: method,
    headers: requestHeaders,
    body: body ? JSON.stringify(body) : null,
  });
};

/**
 * Helper to handle response parsing
 */
export const parseCapResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    const errorText = await response.text();
    let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
    
    try {
      const errorJson = JSON.parse(errorText);
      errorMessage = errorJson.message || errorJson.error || errorMessage;
    } catch {
      // If not JSON, use the text as is
      errorMessage = errorText || errorMessage;
    }
    
    throw new Error(errorMessage);
  }

  // Handle empty responses
  if (response.status === 204) {
    return {} as T;
  }

  return await response.json();
};

